import { Divider } from '../Divider'
import { Educations } from './components/Educations'
import { EmployeeCertificates } from './components/EmployeeCertificates'
import { EmployeeStatusAlert } from './components/EmployeeStatusAlert'
import { GeneralInformation } from './components/GeneralInformation'
import { PersonalInformation } from './components/PersonalInformation'
import { WageProfile } from './components/WageProfile'
import {
  EmployeeProfileQuery_employee,
  EmployeeProfileQuery_employee_employeeCertificates as EmployeeCertificate
} from './typings/EmployeeProfileQuery'

export interface EmployeeProfileProps {
  employee: EmployeeProfileQuery_employee
  onDeleteEmployeeCertificate?: (
    certificate: EmployeeCertificate
  ) => Promise<void>
  onRefreshRemainingHours?: () => Promise<void>
  onSendInvitationReminder?: () => Promise<void>
  onSendMissingContractInformationPushNotification: () => Promise<void>
}

export const EmployeeProfile = ({
  employee,
  onDeleteEmployeeCertificate,
  onRefreshRemainingHours,
  onSendInvitationReminder,
  onSendMissingContractInformationPushNotification
}: EmployeeProfileProps) => {
  return (
    <>
      <EmployeeStatusAlert
        employee={employee}
        onSendInvitationReminder={onSendInvitationReminder}
        onSendMissingContractInformationPushNotification={
          onSendMissingContractInformationPushNotification
        }
      />
      <PersonalInformation
        employee={employee}
        onRefreshRemainingHours={onRefreshRemainingHours}
      />
      <Divider sectionSeparator />
      <GeneralInformation employee={employee} />
      <Divider sectionSeparator />
      <WageProfile employee={employee} />
      <Divider sectionSeparator />
      <Educations employee={employee} />
      <EmployeeCertificates
        employee={employee}
        onDeleteEmployeeCertificate={onDeleteEmployeeCertificate}
      />
    </>
  )
}
